interface PreAuthenticationResponse {
	request_id: string;
	status_code: string;
	user_message_title: string;
	user_message_desc: string;
	body_signature: string;
	data: {
		retry: boolean;
		collect: {
			url: string;
			key: string;
		};
	};
}

interface DataCollectionData {
	url: string;
	key: string;
}

interface Data {
	retry: boolean;
	collect?: DataCollectionData;
}

function isPreAuthenticationResponse(obj: any): obj is PreAuthenticationResponse {
	return obj && 
	typeof obj.request_id === 'string' && 
	typeof obj.status_code === 'string' && 
	typeof obj.user_message_title === 'string' && 
	typeof obj.user_message_desc === 'string' && 
	typeof obj.body_signature === 'string' && 
	typeof obj.data === 'object' && 
	typeof obj.data.retry === 'boolean' && 
	typeof obj.data.collect === 'object' && 
	typeof obj.data.collect.url === 'string' && 
	typeof obj.data.collect.key === 'string';
}

export class PreAuthenticationDto {
	requestID: string;
	statusCode: string;
	userMessageTitle: string;
	userMessageDesc: string;
	bodySignature: string;
	data: Data;

	constructor(json: PreAuthenticationResponse) {
		if (!isPreAuthenticationResponse(json)) {
			throw new Error('Invalid PreAuthenticationResponse json');
		}
		this.requestID = json.request_id;
		this.statusCode = json.status_code;
		this.userMessageTitle = json.user_message_title;
		this.userMessageDesc = json.user_message_desc;
		this.bodySignature = json.body_signature;
		this.data = {
			retry: json.data.retry,
			collect: {
				url: json.data.collect.url,
				key: json.data.collect.key
			}
		};
	}

}
